import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

// API base: REACT_APP_API_URL, or api.phiprinting.com when on phiprinting.com, or same-origin /api for localhost
function getApiBaseUrl(): string {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window === 'undefined') return 'https://api.phiprinting.com/api';
  const origin = window.location.origin;
  if (origin === 'https://phiprinting.com' || origin === 'https://www.phiprinting.com') {
    return 'https://api.phiprinting.com/api';
  }
  return `${origin}/api`;
}
const apiBaseUrl = getApiBaseUrl();
export const API_BASE = apiBaseUrl.replace(/\/api\/?$/, '');

const api: AxiosInstance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Get or create session ID for guest users
export const getSessionId = (): string => {
  let sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = `guest_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('sessionId', sessionId);
  }
  return sessionId;
};

// Add token to requests if available
const token = localStorage.getItem('token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
api.defaults.headers.common['X-Session-Id'] = getSessionId();

// Keep auth and session headers in sync on every request. The session ID is
// always sent (authenticated endpoints ignore it) so the guest cart can be
// transferred to the user account after login via POST /cart/transfer.
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  } else {
    delete config.headers['Authorization'];
  }
  config.headers['X-Session-Id'] = getSessionId();

  return config;
});

// Log failed requests to the console during local development only
if (process.env.NODE_ENV === 'development') {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.config) {
        console.error(
          `[API Error] ${error.config.method?.toUpperCase()} ${error.config.baseURL}${error.config.url}`,
          { status: error.response?.status, data: error.response?.data }
        );
      }
      return Promise.reject(error);
    }
  );
}

export default api;

